<template>
    <b-card
        :title="event.title"
    >
        <div class="event-prop">
            <font-awesome-icon
                icon="clock"
                size="lg"
            ></font-awesome-icon>
            <div>
                {{ $moment(event.event_date).format("LLLL") }}
            </div>
        </div>
        <div class="event-prop">
            <font-awesome-icon
                icon="map-marker-alt"
                size="lg"
            ></font-awesome-icon>
            <div>
                {{ event.loc_name }}
                <div v-if="event.loc_addr">
                    {{ event.loc_addr }}
                </div>
                <div v-if="event.loc_city && event.loc_state && event.loc_zip">
                    {{ event.loc_city }}, {{ event.loc_state }} {{ event.loc_zip }}
                </div>
            </div>
        </div>
        <div class="event-prop">
            <font-awesome-icon
                icon="comment-alt"
                size="lg"
            ></font-awesome-icon>
            <div>
                {{ event.description }}
            </div>
        </div>
        <template
            v-if="(event.view_maps_link && event.loc_addr && event.loc_city && event.loc_state && event.loc_zip) || event.add_calendar_link"
        >
            <hr/>
            <a
                v-if="event.view_maps_link && event.loc_addr && event.loc_city && event.loc_state && event.loc_zip"
                class="card-link"
                :href="mapsLink"
                target="_blank"
            >
                <font-awesome-icon
                    class="mr-1"
                    icon="map"
                ></font-awesome-icon>
                View on Map
            </a>
            <a
                v-if="event.add_calendar_link"
                class="card-link"
                :href="calendarLink"
                target="_blank"
            >
                <font-awesome-icon
                    class="mr-1"
                    icon="calendar-plus"
                ></font-awesome-icon>
                Add to Calendar
            </a>
        </template>
    </b-card>
</template>
<script>
export default {
    props: [ "event" ],
    data: function () {
        return {};
    },
    computed: {
        mapsLink() {
            return "https://www.google.com/maps/place/" + [this.event.loc_addr, this.event.loc_city, this.event.loc_state, this.event.loc_zip].join(",");
        },
        calendarLink() {
            var urlParams = {
                pli: 1,
                sf : true
            };
            if (this.event.title)       urlParams.title       = this.event.title;
            if (this.event.event_date)  urlParams.dates       = this.$moment(this.event.event_date).format();
            if (this.event.description) urlParams.description = this.event.description;
            if (
                this.event.loc_addr  &&
                this.event.loc_city  &&
                this.event.loc_state &&
                this.event.loc_zip
            ) {
                urlParams.location = [this.event.loc_addr, " " + this.event.loc_city, " " + this.event.loc_state + " " + this.event.loc_zip].join(",");
            }
            return "https://calendar.google.com/calendar/u/0/r/eventedit?" + (new URLSearchParams(urlParams)).toString();
        }
    }
}
</script>
<style scoped>
    .event-prop {
        display: grid;
        grid-template-columns: 50px auto;
        margin-top: 25px;
        margin-left: 25px;
    }
</style>